export const normalizeValue = (word: string) => {
  if (word === 'true') return true;
  if (word === 'false') return false;
  return word;
};
